/**
 * Csv Schema of Promocao
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {Promocao} from '@/model/resource/Promocao'

/* TODO: review generated schema */
export class CsvPromocaoSchema extends Schema {
  readonly name = 'CsvPromocao'

  readonly fieldSet: FieldSet<Promocao> = {
    idPromocaoPk: schema => schema.model.idPromocaoPk,
    nome: schema => schema.model.nome,
    urlImagem: schema => schema.model.urlImagem,
    urlRedirect: schema => schema.model.urlRedirect,
    dataInicio: schema => Helper.datetime(schema.model.dataInicio),
    dataFim: schema => Helper.datetime(schema.model.dataFim),
    dataCriacao: schema => Helper.datetime(schema.model.dataCriacao),
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
